<div class="sendmail-info">
    <div class="card">
      <img src="assets/images/email-check.webp" alt="Email Check" class="icon" style="margin-left: auto;margin-right: auto;" />
      <h1>Consultez votre boîte mail</h1>
      <p>Un lien d'activation a été envoyé à votre adresse email. Veuillez le vérifier pour activer votre compte.</p>
      <button (click)="goBack()">Retour</button>
    </div>
  </div>
  